import React, { useContext, useEffect } from 'react';

import { trackerState } from '../../App';
import { LockIcon } from '../Icon';

import style from './index.module.scss';
import { useTranslation } from 'react-i18next';

const appUrl = {
  ko: 'https://dodo-point.onelink.me/PCEC/o626jdio',
  ja: 'https://dodo-point.onelink.me/PCEC/pcafdj2e',
};

export const AccessUnavailable: React.FC = () => {
  const tracker = useContext(trackerState);
  const { t } = useTranslation();

  const locale = window.navigator.language.split('-')[0] ?? 'ko';
  const appLink = locale === 'ja' ? appUrl.ja : appUrl.ko;

  useEffect(() => {
    tracker && tracker.trackEvent('개인정보 만료 페이지', '방문', '개인정보 만료 페이지 방문');
  }, [tracker]);

  return (
    <div className={style.accessWrapper}>
      <div className={style.accessContents}>
        <LockIcon className={style.lockIcon} />
        <div className={style.title}>{t('도도 포인트 앱에서 확인해주세요!')}</div>
        <div className={style.description}>{t('개인정보 보호를 위해 웹 페이지는\n24시간 후 만료됩니다.')}</div>
        <a
          href={appLink}
          target="_system"
          className={style.buttonCta}
          onClick={() => {
            tracker && tracker.trackEvent('개인정보 만료 페이지', '클릭', '앱 열기 버튼 클릭');
          }}
        >
          {t('앱 열기')}
        </a>
      </div>
    </div>
  );
};
